export default __webpack_public_path__ + "aa83b639d58dc26d6a60492de28c4fe9.png";